import { UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import bannerImg from './assets/banner.png';
import * as styles from './styles.css';

interface IPromoBannerAgent {
  mainButtonsRef?: React.Ref<HTMLDivElement>;
}

export const PromoBannerAgent: React.FC<IPromoBannerAgent> = ({ mainButtonsRef }) => {
  return (
    <div data-testid="PromoBannerAgent" className={styles['container']}>
      <div className={styles['wrapper']}>
        <div ref={mainButtonsRef} className={styles['text-content']}>
          <h1>Онлайн-договор аренды – выручит, когда невозможно подписать бумажный</h1>
          <div className={styles['list-item']}>
            <IconFunctionalSuccess16 color="icon-inverted-default" />
            <UIText2 color="text-inverted-default">Больше внимания объявлению со значком «Онлайн-договор»</UIText2>
          </div>
          <div className={styles['list-item']}>
            <IconFunctionalSuccess16 color="icon-inverted-default" />
            <UIText2 color="text-inverted-default">Бесплатен для всех участников сделки</UIText2>
          </div>
          <div className={styles['list-item']}>
            <IconFunctionalSuccess16 color="icon-inverted-default" />
            <UIText2 color="text-inverted-default">Подписывается через безопасное приложение</UIText2>
          </div>
        </div>
        <div className={styles['bg-image']}>
          <img src={bannerImg} />
        </div>
      </div>
    </div>
  );
};

PromoBannerAgent.displayName = 'PromoBannerAgent';
